// import {useNormalizer} from '@sttedra_ui/framework';
// const {getString} = useNormalizer();

class ProvinceApiResponseModel {
  // #region Props

  // #endregion
  constructor({id, name, region}) {
    return {
      id,
      name,
      region,
    };
  }
}

export default ProvinceApiResponseModel;
